module.exports = __webpack_public_path__ + "static/media/commit-title.ad25fb1a.svg";